import { exhaustiveGuard } from '@libs/utils';

import { isFeatureToggleActive } from '../customFeatureToggles';

import type { StatsigExperimentName } from './statsigFeatureToggleTypes';

let isHotelDetailsRoomCardsGridLayoutExperiment = false;
let isNewConfigurationPanelExperiment = false;
let isReliabilityTestExperiment = false;
let isSingleHotelCalendarMetaExperiment = false;
let isSingleHotelCalendarNonMetaExperiment = false;
let isConfigPanelDoneExperiment = false;
let isNewTransportBannerExperiment = false;
let isActivityListExperiment = false;

export function setExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  switch (experimentName) {
    case 'reliability_test':
      isReliabilityTestExperiment = value;
      break;

    case 'hotel_details_room_cards_grid_layout':
      isHotelDetailsRoomCardsGridLayoutExperiment = value;
      break;

    case 'configuration_panel':
      isNewConfigurationPanelExperiment = value;
      break;

    case 'single_hotel_calendar':
      isSingleHotelCalendarMetaExperiment = value;
      break;

    case 'single_hotel_calendar_non_meta':
      isSingleHotelCalendarNonMetaExperiment = value;
      break;

    case 'configuration_panel_done_button':
      isConfigPanelDoneExperiment = value;
      break;

    case 'transport_banner':
      isNewTransportBannerExperiment = value;
      break;

    case 'activity_list':
      isActivityListExperiment = value;
      break;

    default:
      exhaustiveGuard(experimentName, 'Invalid experiment name');
  }
}

function getExperimentValue(experimentName: StatsigExperimentName): boolean {
  switch (experimentName) {
    case 'hotel_details_room_cards_grid_layout':
      return isHotelDetailsRoomCardsGridLayoutExperiment;

    case 'configuration_panel':
      return isNewConfigurationPanelExperiment;

    case 'reliability_test':
      return isReliabilityTestExperiment;

    case 'single_hotel_calendar':
      return isSingleHotelCalendarMetaExperiment;

    case 'single_hotel_calendar_non_meta':
      return isSingleHotelCalendarNonMetaExperiment;

    case 'configuration_panel_done_button':
      return isConfigPanelDoneExperiment;

    case 'transport_banner':
      return isNewTransportBannerExperiment;

    case 'activity_list':
      return isActivityListExperiment;

    default:
      exhaustiveGuard(experimentName, 'Invalid experiment name');
  }
}

export function isExperiment(experimentName: StatsigExperimentName): boolean {
  return (
    (getExperimentValue(experimentName) ||
      isFeatureToggleActive(experimentName)) &&
    !isFeatureToggleActive(`!${experimentName}`)
  );
}
